var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7136 48.4679C33.7293 47.7036 32.1583 46.9168 30.6844 46.3417C28.1 45.3359 25.812 44.9798 22.1023 46.5359C21.2434 46.8944 20.3097 47.3575 19.2765 47.9376C16.9013 49.2746 14.5535 50.7859 11.8944 51.3834C9.23295 51.981 6.10834 51.4506 4.43026 49.2995C1.53727 45.5898 4.26596 40.232 4.29335 36.1712C4.33814 29.2772 -3.07625 21.1732 1.48241 14.7348C5.67263 8.81921 14.9195 11.9512 20.7753 8.7644C25.2841 6.3145 27.988 0.406407 33.1044 0.0179817C36.6248 -0.248408 39.8092 2.48283 41.2656 5.69955C44.1861 12.1504 41.7188 20.1574 45.4359 26.292C46.9322 28.7643 49.3199 30.6266 50.6668 33.1836C55.5865 42.52 44.353 51.7967 35.7136 48.4679Z",
    fill: "url(#paint0_linear_3_156)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_156",
    x1: 36.6693,
    y1: 7.63595,
    x2: 16.4565,
    y2: 47.4713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2512,
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7588,
    stopColor: "#FF1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.225e7fcf1cc2de944fc6b56a079b2f56.svg";
export { ForwardRef as ReactComponent };